import Link from 'next/link'
import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/**
 * Auth screens carry the brand accent on links and use colour, not an
 * underline, as the hover cue. Exported separately for the plain anchors that
 * cannot be `next/link` (external policy pages).
 */
export const AUTH_LINK_CLASS = 'font-medium text-blue-600 transition-colors hover:text-blue-700'

export function AuthLink({
  href,
  className,
  children,
}: {
  href: string
  className?: string
  children: ReactNode
}) {
  return (
    <Link href={href} className={cn(AUTH_LINK_CLASS, className)}>
      {children}
    </Link>
  )
}
